import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Stack,
  Typography,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  InputBase,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import Utils from "../../core/Utils";
import styled from "@emotion/styled";
import { Virtuoso } from "react-virtuoso";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteOutline";
import ClearIcon from "@mui/icons-material/Clear";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const CategoryRow = React.memo(function CategoryRow({
  item,
  isChecked,
  onCheckboxChange,
  isReadOnlyCampaign
}) {
  return (
    <Card className="card p-1">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          cursor: isReadOnlyCampaign ? "" : "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => {
          if (!isReadOnlyCampaign) {
            onCheckboxChange(
              { target: { checked: !isChecked } },
              item.class,
              "Class"
            );
          }
        }}
      >
        <Checkbox
          alignSelf="center"
          checked={isChecked}
          disabled={isReadOnlyCampaign}
          onChange={(e) =>
            onCheckboxChange(e, item.class, "Class")
          }
          onClick={(e) => e.stopPropagation()}
        />

        <Stack>
          <Typography fontSize="1.6rem" fontWeight="600">
            {item.class}
          </Typography>
          <Typography fontSize="13px">
            {item.classDescription}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
});

const DepartmentRow = React.memo(function DepartmentRow({
  item,
  isChecked,
  onCheckboxChange,
  isReadOnlyCampaign
}) {
  return (
    <Card className="card p-1">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          cursor: isReadOnlyCampaign ? "" : "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => {
          if (!isReadOnlyCampaign) {
            onCheckboxChange(
              { target: { checked: !isChecked } },
              item.department,
              "Department"
            );
          }
        }}
      >
        <Checkbox
          alignSelf="center"
          checked={isChecked}
          disabled={isReadOnlyCampaign}
          onChange={(e) =>
            onCheckboxChange(e, item.department, "Department")
          }
          onClick={(e) => e.stopPropagation()}
        />

        <Stack>
          <Typography fontSize="1.6rem" fontWeight="600">
            {item.department}
          </Typography>
          <Typography fontSize="13px">
            {item.departmentDescription}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
});

const ProductRow = React.memo(function ProductRow({
  item,
  isChecked,
  onCheckboxChange,
  isReadOnlyCampaign
}) {
  return (
    <Card className="card p-1">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          cursor: isReadOnlyCampaign ? "" : "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => {
          if (!isReadOnlyCampaign) {
            onCheckboxChange(
              { target: { checked: !isChecked } },
              item.id,
              "Item"
            );
          }
        }}
      >
        <Checkbox
          alignSelf="center"
          checked={isChecked}
          disabled={isReadOnlyCampaign}
          onChange={(e) =>
            onCheckboxChange(e, item.id, "Item")
          }
          onClick={(e) => e.stopPropagation()}
        />

        <Stack>
          <Typography fontSize="1.6rem" fontWeight="600">
            {item.shortDesc}
          </Typography>
          <Typography fontSize="13px">
            {item.description}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
});

const  SelectedProductRow = React.memo(function ProductRow({
  item,
  isChecked,
  onCheckboxChange,
  isReadOnlyCampaign,
  selectedRadio,
  classificationTypes,
}) {
  return (
    <Card className="card p-1">
      <Stack
        direction="row"
        spacing={2}
        sx={{
          cursor: isReadOnlyCampaign ? "" : "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
        onClick={() => {
          if (!isReadOnlyCampaign) {
            onCheckboxChange(
              { target: { checked: !isChecked } },
              selectedRadio === classificationTypes.Department ? item.department : 
              selectedRadio === classificationTypes.Class ? item.class : item.id,
              selectedRadio
            );
          }
        }}
      >
        {!isReadOnlyCampaign && <Tooltip title="Remove" placement="bottom">
          <Button onClick={(e) => 
             onCheckboxChange(e,
               selectedRadio === classificationTypes.Department ? item.department : 
              selectedRadio === classificationTypes.Class ? item.class : item.id,
              selectedRadio)
          } className="remove-btn">
            <DeleteForeverRoundedIcon style={{ color: "#ff0000" }} />
          </Button>
        </Tooltip>}

        <Stack>
          <Typography fontSize="1.6rem" fontWeight="600">
            {selectedRadio === classificationTypes.Department ? item.department :  
            selectedRadio === classificationTypes.Class ? item.class :  item.shortDesc}
          </Typography>
          <Typography fontSize="13px">
            {selectedRadio === classificationTypes.Department ? item.departmentDescription : 
            selectedRadio === classificationTypes.Class ? item.classDescription : item.description}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
});






 const ProductSelectionModal = ({
  open,
  onClose,
  title = "Select Products",
  showRadioGroup = false, // true for Buy & Discount
  radioValue,
  onRadioChange,
  searchValue,
  onSearchChange,
  onAddClick,
  addButtonDisabled,
  filteredCategories,
  filteredDepartments,
  filteredProducts,
  productsSelection, // object of selected ids by ClassificationType
  onCheckboxChange,
  classificationTypes,
  isReadOnlyCampaign,
}) => {

  // const [allNewCategories, setAllNewCategories] = useState([]);
  // const [allNewDepartments, setAllDepartments] = useState([]);
  // const [allNewProducts, setAllProducts] = useState([]);

  const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
      getSelectedProducts();
  },[radioValue,productsSelection])

  const getSelectedProducts = () => {
    let allNewCategories = filteredCategories;
    let allNewDepartments = filteredDepartments;
    let allNewProducts = filteredProducts;
    const selectedList =
  radioValue === classificationTypes.Class
    ? allNewCategories.filter(c =>
        productsSelection[classificationTypes.Class]?.includes(c.class)
      )
    : radioValue === classificationTypes.Department
    ? allNewDepartments.filter(d =>
        productsSelection[classificationTypes.Department]?.includes(
          d.department
        )
      )
    : allNewProducts.filter(p =>
        productsSelection[classificationTypes.Item]?.includes(p.id)
      );
      setSelectedProducts(selectedList)
  }

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      className="cs-modal-sec"
      open={open}
      PaperProps={{
        style: { width: "70%", maxWidth: "90%" },
      }}
    >
        {/* <Stack direction="row" justifyContent="space-between">
          <Typography
            level="h2"
            component="h2"
            fontWeight="600"
            fontSize="2rem"
            alignSelf="center"
          >
            {title}
          </Typography>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack> */}

        <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() =>  onClose() }
              >
                <Typography
                  level="h3"
                  component="h3"
                  fontWeight="600"
                  fontSize="2rem"
                  className="h3"
                >
                  {title}
                </Typography>
              </BootstrapDialogTitle>

  {/* ------- Content Area -------- */}
        <DialogContent
          dividers
          className="modal-dialog-content"
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "70vh", // fixed height for dialog
            padding: "16px !important",
          }}
        >

        <Stack  direction="row" spacing={2}>
          <Box
            sx={{
              padding: 2,
              height: "100%",
              overflow: "hidden", // Virtuoso handles scroll
              marginTop: 1,
              flexGrow: 1,
            }}
            className="card white-bg"
          >
        <Stack mb={5} spacing={2} >
          {/* ===== RadioGroup (optional) ===== */}
          {showRadioGroup && (
            <FormControl className="font-size-14 m-0">
              <RadioGroup
                name="classification-group"
                sx={{ flexDirection: "row" }}
                onChange={onRadioChange}
                value={radioValue}
              >
                <FormControlLabel
                  value={classificationTypes.Class}
                  control={<Radio />}
                  label="Category"
                />
                <FormControlLabel
                  value={classificationTypes.Department}
                  control={<Radio />}
                  label="Department"
                />
                <FormControlLabel
                  value={classificationTypes.Item}
                  control={<Radio />}
                  label="Product"
                />
              </RadioGroup>
            </FormControl>
          )}

          {/* ===== Search ===== */}
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
            className="font-size-14"
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search products"
              inputProps={{ "aria-label": "Search products" }}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value, radioValue)}
            />
            {searchValue && (
                <IconButton
                  sx={{ p: "10px" }}
                  aria-label="clear"
                  onClick={() => onSearchChange("",radioValue)}
                >
                  <ClearIcon />
                </IconButton>
              )}
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>

          {/* ===== Category Section ===== */}
          {/* {radioValue === classificationTypes.Class &&
            !Utils.IsNullOrEmptyArray(filteredCategories) && (
              <Stack className="font-size-16" spacing={1}>
                {filteredCategories.map((category) => {
                  const isChecked =
                    !Utils.IsNullOrEmptyArray(
                      productsSelection[classificationTypes.Class]
                    ) &&
                    productsSelection[classificationTypes.Class].includes(
                      category.class
                    );
                  return (
                    <Card key={category.class} className="card p-1">
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          cursor: isReadOnlyCampaign ? "" : "pointer",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => {
                          if (!isReadOnlyCampaign) {
                            onCheckboxChange(
                              { target: { checked: !isChecked } },
                              category.class,
                              classificationTypes.Class
                            )
                          }
                        }
                        }
                      >
                        <Checkbox
                          alignSelf="center"
                          checked={isChecked}
                          disabled={isReadOnlyCampaign}
                          onChange={(e) =>
                            onCheckboxChange(
                              e,
                              category.class,
                              classificationTypes.Class
                            )
                          }
                          onClick={(e) => e.stopPropagation()}
                        />
                        <Stack>
                          <Typography fontSize="1.6rem" fontWeight="600">
                            {category.class}
                          </Typography>
                          <Typography fontSize="13px">
                            {category.classDescription}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  );
                })}
              </Stack>
            )} */}

            {/* ===== Class Section ===== */}
{radioValue === classificationTypes.Class &&
  !Utils.IsNullOrEmptyArray(filteredCategories) && (
    <Virtuoso
      style={{ height: "280px" }}
      overscan={200}
      totalCount={filteredCategories.length}
      itemContent={(index) => {
        const item = filteredCategories[index];
        const isChecked =
          productsSelection[classificationTypes.Class]?.includes(item.class);

        return (
            <CategoryRow
              item={item}
              isChecked={isChecked}
              onCheckboxChange={onCheckboxChange}
              isReadOnlyCampaign={isReadOnlyCampaign}
            />
        );
      }}
       components={{
        Item: (props) => <div {...props} style={{ marginBottom: "8px" }} />,
      }}
    />
)}


          {/* ===== Department Section ===== */}
          {/* {radioValue === classificationTypes.Department &&
            !Utils.IsNullOrEmptyArray(filteredDepartments) && (
              <Stack className="font-size-16" spacing={1}>
                {filteredDepartments.map((dept) => {
                  const isChecked =
                    !Utils.IsNullOrEmptyArray(
                      productsSelection[classificationTypes.Department]
                    ) &&
                    productsSelection[classificationTypes.Department].includes(
                      dept.department
                    );
                  return (
                    <Card key={dept.department} className="card p-1">
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          cursor: "pointer",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() =>
                          onCheckboxChange(
                            { target: { checked: !isChecked } },
                            dept.department,
                            classificationTypes.Department
                          )
                        }
                      >
                        <Checkbox
                          alignSelf="center"
                          checked={isChecked}
                          disabled={isReadOnlyCampaign}
                          onChange={(e) =>
                            onCheckboxChange(
                              e,
                              dept.department,
                              classificationTypes.Department
                            )
                          }
                          onClick={(e) => e.stopPropagation()}
                        />
                        <Stack>
                          <Typography fontSize="1.6rem" fontWeight="600">
                            {dept.department}
                          </Typography>
                          <Typography fontSize="13px">
                            {dept.departmentDescription}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  );
                })}
              </Stack>
            )} */}
            {/* ===== Department Section ===== */}
        {radioValue === classificationTypes.Department &&
          !Utils.IsNullOrEmptyArray(filteredDepartments) && (
            <Virtuoso
              style={{ height: "280px" }}
              overscan={200}
              totalCount={filteredDepartments.length}
              itemContent={(index) => {
                const item = filteredDepartments[index];
                const isChecked =
                  productsSelection[classificationTypes.Department]?.includes(
                    item.department
                  );

                return (
                    <DepartmentRow
                      item={item}
                      isChecked={isChecked}
                      onCheckboxChange={onCheckboxChange}
                      isReadOnlyCampaign={isReadOnlyCampaign}
                    />
                );
              }}
               components={{
                  Item: (props) => <div {...props} style={{ marginBottom: "8px" }} />,
                }}
            />
        )}


          {/* ===== Product Section ===== */}
          {/* {radioValue === classificationTypes.Item &&
            !Utils.IsNullOrEmptyArray(filteredProducts) && (
              <Stack className="font-size-16" spacing={1}>
                {filteredProducts.map((product) => {
                  const isChecked =
                    !Utils.IsNullOrEmptyArray(
                      productsSelection[classificationTypes.Item]
                    ) &&
                    productsSelection[classificationTypes.Item].includes(
                      product.id
                    );
                  return (
                    <Card key={product.id} className="card p-1">
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          cursor: "pointer",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={(e) =>
                          onCheckboxChange(
                            { target: { checked: !isChecked } },
                            product.id,
                            classificationTypes.Item
                          )
                        }
                      >
                        <Checkbox
                          alignSelf="center"
                          checked={isChecked}
                          disabled={isReadOnlyCampaign}
                          onChange={(e) =>
                            onCheckboxChange(
                              e,
                              product.id,
                              classificationTypes.Item
                            )
                          }
                          onClick={(e) => e.stopPropagation()}
                        />
                        <Stack>
                          <Typography fontSize="1.6rem" fontWeight="600">
                            {product.shortDesc}
                          </Typography>
                          <Typography fontSize="13px">
                            {product.description}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  );
                })}
              </Stack>
            )} */}

            {/* ===== Item Section ===== */}
{radioValue === classificationTypes.Item &&
  !Utils.IsNullOrEmptyArray(filteredProducts) && (
    <Virtuoso
      style={{ height: "280px" }}
      overscan={200}
      totalCount={filteredProducts.length}
      itemContent={(index) => {
        const item = filteredProducts[index];
        const isChecked =
          productsSelection[classificationTypes.Item]?.includes(item.id);

        return (
            <ProductRow
              item={item}
              isChecked={isChecked}
              onCheckboxChange={onCheckboxChange}
              isReadOnlyCampaign={isReadOnlyCampaign}
            />
        );
      }}
       components={{
          Item: (props) => <div {...props} style={{ marginBottom: "8px" }} />,
        }}
    />
)}


          
        </Stack>
        </Box>
        
        <Box
            sx={{
              padding: 2,
              height: "100%",
              overflow: "hidden", // Virtuoso handles scroll
              marginTop: 1,
              flexGrow: 1,
            }}
            className="card white-bg"
          >
            <Typography
                      level="h4"
                      component="h4"
                      fontWeight="600"
                      fontSize="2rem"
                      className="h3"
                    >Selected Items</Typography>

                    {
  !Utils.IsNullOrEmptyArray(selectedProducts) && (
    <Virtuoso
      style={{ height: "90%" }}
      overscan={200}
      totalCount={selectedProducts.length}
      itemContent={(index) => {
        const item = selectedProducts[index];
        const isChecked = true;
          

        return (
            <SelectedProductRow
              item={item}
              isChecked={isChecked}
              onCheckboxChange={onCheckboxChange}
              isReadOnlyCampaign={isReadOnlyCampaign}
              selectedRadio={radioValue}
              classificationTypes={classificationTypes}
            />
        );
      }}
       components={{
        Item: (props) => <div {...props} style={{ marginBottom: "8px" }} />,
      }}
    />
)}
          </Box>
        </Stack>
        

        {/* ===== Footer Buttons ===== */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            pt={2}
          >
            <FormControl>
              <Button className="btn btn-secondary" onClick={onClose}>
                Close
              </Button>
            </FormControl>
            {!isReadOnlyCampaign && <FormControl>
              <Button
                variant="contained"
                className="btn btn-primary"
                disabled={addButtonDisabled}
                onClick={onAddClick}
              >
                Add
              </Button>
            </FormControl>}
          </Stack>

        </DialogContent>
    </BootstrapDialog>
  );
}

export default ProductSelectionModal;
